import { SxProps, Theme } from "@mui/material";
import { palette } from "../../themes/color-palette";

export const HeaderMegaMenuSX: Record<string, SxProps<Theme>> = {
  wrapper: {
    maxHeight: "620px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    overflow: "hidden",
    // "@media (min-width:1367px)": {
    //   height: "400px",
    // },

    // "@media (max-width:1366px)": {
    //   height: "400px",
    // },
    // "@media (max-width:1024px)": {
    //   height: "520px",
    // },
  },
  leftColumn: {
    pt: 3,
    pb: 3,
    pl: 5,
    pr: 2.5,
    display: "flex",
    flexDirection: "column",
    background: "#FFF",
    marginRight: "5px",
    borderRight: "2px solid #EFEFEF",
  },
  leftColumnItems: {
    "@media (min-width:1367px)": {
      maxHeight: "none", // remove height limitation
      overflowY: "visible", // no scroll needed
    },

    // "@media (max-width:1366px)": {
    //   maxHeight: "calc(100vh - 200px)", // reduced bottom spacing
    //   overflowY: "auto",
    // },

    "@media (max-width:1024px)": {
      maxHeight: "calc(100vh - 200px)",
      overflowY: "auto",
    },

    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: palette.gray.neutralGray100,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: palette.gray.neutralGray400,
      borderRadius: "3px",
      "&:hover": {
        background: palette.gray.neutralGray500,
      },
    },
    listStyle: "none",
    p: 0,
    m: 0,
  },
  leftColumnHeading: {
    color: "#848484",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "20px",
    textTransform: "uppercase",
    mb: 2,
    mt: 0,
  },

  rightColumn: {
    pt: 2,
    pb: 3,
    px: 5,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },

  rightColumnHeading: {
    fontWeight: 700,
    mb: 1,
    fontSize: "16px",
    color: palette.text.primary,
    fontFamily: "Montserrat, sans-serif",
  },

  rightColumnHeadingDesc: {
    mb: 1,
    fontSize: "14px",
    color: palette.text.primary,
    fontFamily: "Montserrat, sans-serif",
    lineHeight: "20px",
  },

  extlink: {
    color: palette.primary.main,
    textDecoration: "none",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
  },

  extlinkText: {
    color: "#5D89A2",
    textDecoration: "none",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    fontWeight: "400",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  staticLink: {
    color: palette.primary.main,
    textTransform: "none",
    justifyContent: "flex-start",
    padding: "2px",
    ml: "10px",
    mt: "8px",
    "& .MuiButton-startIcon": {
      marginRight: "8px",
    },
    "& .MuiButton-endIcon": {
      marginLeft: "auto",
    },
  },

  catalogueItemsWrapper: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: palette.gray.neutralGray100,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: palette.gray.neutralGray400,
      borderRadius: "4px",
      "&:hover": {
        background: palette.gray.neutralGray500,
      },
    },
  },
  catalogueItemsLists: {
    listStyle: "none",
    p: 0,
    m: 0,
  },
  catalogueItemHeading: {
    fontWeight: 700,
    // mb: 0.5,
    fontSize: "15px",
    color: "#000",
    lineHeight: "20px",
  },

  catNavLink: {
    color: palette.text.primary,
    textDecoration: "none",
    fontSize: "14px",
    display: "block",
    fontWeight: 400,
    "&:hover": {
      textDecoration: "underline",
    },
  },

  seeAll: {
    color: "#5D89A2",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 400,
    maxHeight: "42px",
    p: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  seeAllText: {
    color: "#5D89A2 !important",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  navButtonPrimary: {
    borderColor: "#252427",
    // border: "2px !important",
    color: "#FFFFF",
    textTransform: "none",
    fontSize: "13px !important",
    fontWeight: 700,
    py: "8px !important",
    px: "8px !important",
    // "&:hover, a:hover": {
    //   borderColor: palette.primary.main,
    //   fontWeight: "400",
    //   backgroundColor: palette.primary.light + "10",
    // },
  },

  leftColumnMenuListItem: {
    mb: "3px",
    padding: "2px",
    marginBottom: "12px",
    borderRadius: "8px",
    position: "relative",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: palette.gray.neutralGray200,
    },
    "&.active": {
      backgroundColor: palette.gray.neutralGray100,
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: "4px",
        backgroundColor: palette.primary.main,
      },
      "&:hover": {
        backgroundColor: palette.gray.neutralGray100,
      },
    },
  },

  menuListItemButton: {
    display: "flex",
    padding: "4px !important", // Override padding from styled-button, need to remove this
    alignItems: "center",
    fontFamily: "Montserrat, sans-serif",
    fontSize: "14px",
    lineHeight: "10px",
    justifyContent: "left",
    color: "#000",
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",

    "@media (max-width:1366px)": {
      maxWidth: "333px",
    },
    "@media (max-width:1024px)": {
      maxWidth: "340px",
    },

    "&.active": {
      color: palette.primary.main,
      fontWeight: 700,
    },

    "& .MuiButton-startIcon": {
      marginRight: "12px",
      marginLeft: 0,
      "& svg path": {
        fill: "currentColor",
      },
    },

    "& .MuiButton-endIcon": {
      marginLeft: "auto",
      marginRight: 0,
      "& svg": {
        color: "currentColor",
      },
    },

    "& .MuiButton-label": {
      justifyContent: "flex-start",
      textAlign: "left",
    },

    "& .MuiTypography-root": {
      color: "currentColor",
      fontFamily: "Montserrat, sans-serif",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "inherit",
      lineHeight: "10px",
      textAlign: "left",
    },
  },
};

export const HeaderMobileMegaMenuSX: Record<string, SxProps<Theme>> = {
  navItemWrapper: {
    width: "100%",
    height: "100vh",
    maxHeight: "calc(100vh - 210px)",
    overflowY: "auto",
    overflowX: "hidden",
    paddingBottom: "60px", // extra padding to show last item on iOS rubberband scrolling in safari
  },
  navItemChildrens: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    pb: 5,
  },
  navToplevelItem: {
    textTransform: "uppercase",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flex: 1,
    fontWeight: 700,
  },
  navSecondlevelItem: {
    marginLeft: "12px",
    flex: 1,
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "20px",
    color: "rgba(0, 0, 0, 1)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  navThirdlevelItem: {
    fontWeight: 700,
    ".MuiTypography-root, .MuiButtonBase-root": {
      fontSize: "14px",
      fontWeight: "700 !important",
      color: "rgba(0, 0, 0, 1)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  navProductsItems: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "left",
    padding: "12px 16px",
    "& .MuiButton-endIcon": {
      marginLeft: "auto",
      marginRight: 0,
      flexShrink: 0,
    },
    "& .MuiButton-label": {
      display: "flex",
      alignItems: "center",
      flex: 1,
      minWidth: 0,
      justifyContent: "flex-start",
    },
  },
  navStaticbutton: {
    position: "absolute",
    background: "white",
    bottom: "0px",
    padding: " 10px 20px",
    width: "100%",
  },
  catthumbIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    flexShrink: 0,
    marginRight: "12px",
  },
};
